import(/* webpackMode: "eager" */ "/vercel/path0/app/(global)/cgv/page.tsx");
